"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFormValues = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const parseFormValues = ({
  customerId,
  formValues: {
    author,
    cons,
    productCode: productCodeFromForm,
    pros,
    reviewText,
    score
  },
  orderId,
  productCode: productCodeFromEvent
}) => {
  const productCode = productCodeFromForm ?? productCodeFromEvent;
  // Extract items and include current input value if it exists
  const finalPros = [...(pros?.items ?? [])];
  const propsInputValue = pros?.inputValue.trim();
  if (propsInputValue && !finalPros.includes(propsInputValue)) {
    finalPros.push(propsInputValue);
  }
  const finalCons = [...(cons?.items ?? [])];
  const consInputValue = cons?.inputValue.trim();
  if (consInputValue && !finalCons.includes(consInputValue)) {
    finalCons.push(consInputValue);
  }
  return {
    author,
    cons: finalCons,
    pros: finalPros,
    reviewText,
    score: score ?? 1,
    reviewDate: new Date(),
    reviewState: _globalApiClientReact.GlobalCustomerFeedbackReviewDtoReviewState.AwaitingApproval,
    customerId: String(customerId),
    orderId,
    productCode
  };
};
exports.parseFormValues = parseFormValues;
